import Panel from './Panel'
import PanelFooter from './Components/PanelFooter'
import { PanelWrapper } from './Styles'

export default Panel
export { PanelWrapper, PanelFooter }
